import React from 'react';
import { Row } from 'react-table';
import { PortfolioTransactionsType } from 'services/requests';
import Table from 'components/Table';
import EmptyPage from 'components/EmptyPage';
import {
  TransactionsColumnsType,
  MapData,
  PortfolioTransactionsTableSign,
  getColumns,
} from '../../UserTransactionsTable.columns';

import messages from './RenderTransactionsTable.messages';

type Props = {
  columns: TransactionsColumnsType[];
  transactionsListData?: PortfolioTransactionsType;
  items?: MapData;
  onAssetClick: (row: Row<PortfolioTransactionsTableSign>) => void;
};

const RenderTransactionsTable: React.FC<Props> = ({
  columns,
  transactionsListData,
  items,
  onAssetClick,
}) => (
  <Table<PortfolioTransactionsTableSign>
    columns={getColumns(columns)}
    data={items ?? []}
    onRowClick={onAssetClick}
    headerFilters={{ date: true }}
    shouldShowCustomBody={transactionsListData && items?.length === 0}
    customBody={
      <>
        <EmptyPage message={messages.noTransactions} />
      </>
    }
  />
);

export default RenderTransactionsTable;
